"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotificationBellIconButton = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
const NotificationBellIconButton = exports.NotificationBellIconButton = (0, _mui.styled)(_components.IconButton)(({
  theme
}) => ({
  color: theme.palette.text.primary,
  fontSize: '3rem',
  padding: 0,
  '&:hover, &:focus, &:active': {
    background: 'none',
    color: theme.palette.text.primary
  }
}));